import sileo from 'sileo';

const Invoice = new sileo.Model('bposeats', 'invoices');
const StaffingDeposit = new sileo.Model('bposeats', 'staffing-deposit-transactions');
const InvoiceDetail = new sileo.Model('bposeats', 'invoice-detail');
const EmployeeCommission = new sileo.Model('bposeats', 'employee-commissions');
const BulkEmployeeCommission = new sileo.Model('bposeats', 'bulk-employee-commissions');
const BIRForm2307 = new sileo.Model('bposeats', 'bir-form-2307');
const InvoiceWithoutBIRForm2307 = new sileo.Model('bposeats', 'invoices-without-bir-form-2307');
const BIRForm2307AmazonFormData = new sileo.Model('bposeats', 'bir-form-2307-amazon-form');


const actions = {
    createBIRForm2307(context, data) {
        let formData = new FormData();

        formData.append('month_affected', data.monthAffected);
        formData.append('uuid', data.uuid);
        formData.append('invoices', JSON.stringify(data.invoices));

        return BIRForm2307.objects.create(formData);
    },

    fetchBIRForm2307AmazonFormData(context, filters = {}) {
        return BIRForm2307AmazonFormData.objects.filter(filters);
    },

    fetchBIRForm2307Submissions(context, filters = {}) {
        return BIRForm2307.objects.filter(filters);
    },

    fetchInvoices(context, filters = {}) {
        return Invoice.objects.filter(filters);
    },

    fetchInvoicesWithoutBIRForm2307(context, filters = {}) {
        return InvoiceWithoutBIRForm2307.objects.filter(filters);
    },

    fetchStaffingDepositHistory(context, filters = {}) {
        return StaffingDeposit.objects.filter(filters);
    },

    fetchInvoiceDetails(context, pk) {
        return InvoiceDetail.objects.get(pk);
    },

    createEmployeeCommission(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return EmployeeCommission.objects.create(form);
    },

    updateEmployeeCommission(context, data) {
        const form = new FormData();
        const { pk } = data;
        for (let key in data) {
            form.append(key, data[key]);
        }
        return EmployeeCommission.objects.update({ pk: pk }, form);
    },

    filterEmployeeCommission(context, filters = {}) {
        return EmployeeCommission.objects.filter(filters);
    },

    bulkUpdateCreateEmployeeCommission(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return BulkEmployeeCommission.objects.create(form);
    },
};

export default {
    namespaced: true,
    actions
};
